import { QueryClient } from '@tanstack/react-query';

/**
 * Shared defaults: cached data is shown immediately when revisiting a route;
 * background refetch when stale (see staleTime).
 */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60 * 1000,
      gcTime: 5 * 60 * 1000,
      refetchOnWindowFocus: true,
      retry: 1,
    },
  },
});
